import {CalendarDateTime, type DateValue} from '@internationalized/date'

/**
 * Convert reka-ui DateValue to API string format 'yyyy-MM-dd HH:mm'
 */
export function dateValueToApiString(value: DateValue): string {
  const year = String(value.year).padStart(4, '0')
  const month = String(value.month).padStart(2, '0')
  const day = String(value.day).padStart(2, '0')

  if ('hour' in value) {
    const hour = String(value.hour).padStart(2, '0')
    const minute = String(value.minute).padStart(2, '0')
    return `${year}-${month}-${day} ${hour}:${minute}`
  }

  return `${year}-${month}-${day} 00:00`
}

/**
 * Convert API string format 'yyyy-MM-dd HH:mm' to reka-ui CalendarDateTime
 */
export function apiStringToDateValue(str: string): CalendarDateTime {
  // Handles both 'yyyy-MM-dd HH:mm' and 'yyyy-MM-dd'
  const parts = str.split(' ')
  const dateParts = parts[0]!.split('-').map(Number)
  const year = dateParts[0]!
  const month = dateParts[1]!
  const day = dateParts[2]!

  if (parts[1]) {
    const timeParts = parts[1].split(':').map(Number)
    return new CalendarDateTime(year, month, day, timeParts[0]!, timeParts[1]!)
  }

  return new CalendarDateTime(year, month, day)
}

/**
 * Convert JS Date to reka-ui CalendarDateTime
 */
export function jsDateToDateValue(date: Date): CalendarDateTime {
  return new CalendarDateTime(
    date.getFullYear(),
    date.getMonth() + 1,
    date.getDate(),
    date.getHours(),
    date.getMinutes()
  )
}

/**
 * Convert reka-ui DateValue to JS Date
 */
export function dateValueToJsDate(value: DateValue): Date {
  if ('hour' in value) {
    return new Date(value.year, value.month - 1, value.day, value.hour, value.minute)
  }
  return new Date(value.year, value.month - 1, value.day)
}
